import type { ReactNode } from 'react';

import { cn } from '@/lib/cn';

/** CSS-only tooltip so disabled buttons can still explain themselves (W6 Import from QuickBooks). */
export function Tooltip({
  text,
  children,
  className,
}: {
  text: string;
  children: ReactNode;
  className?: string | undefined;
}) {
  return (
    <span className={cn('group relative inline-flex', className)} tabIndex={0}>
      {children}
      <span
        role="tooltip"
        className="pointer-events-none absolute bottom-full left-1/2 z-40 mb-1.5 w-max max-w-60 -translate-x-1/2 rounded-md bg-ink px-2 py-1 text-[11px] font-medium text-on-ink opacity-0 shadow transition-opacity group-hover:opacity-100 group-focus-visible:opacity-100"
      >
        {text}
      </span>
    </span>
  );
}
